import React, {useCallback, useMemo} from 'react';
import cx from 'classnames';
import {IconUnit} from '~/common/fabric/Card/components/IconUnit/IconUnit';
import './Icons.sass';

const getIconId = (icon) => (typeof icon === 'object' ? icon?.id : icon || 'none');
export const Icons = ({
  icons = [],
  onClick,
  square = false,
  selectedIcon,
  height = 32,
  width = 32,
  className,
  mobile,
  hideAnimatedIndicator = false,
  outline = false,
  flipEnvelope,
  showEnvelopeFront,
}) => {
  const onClickHandler = useCallback(onClick, [onClick]);

  const iconsMemo = useMemo(
    () =>
      icons?.map((icon, idx) => {
        const iconId = getIconId(icon);
        return (
          <IconUnit
            key={iconId}
            icon={icon}
            onClick={onClickHandler}
            square={square}
            isActive={getIconId(selectedIcon) === iconId}
            height={height}
            width={width}
            mobile={mobile}
            hideAnimatedIndicator={hideAnimatedIndicator}
            outline={outline}
            loading={idx < 8 ? 'eager' : 'lazy'}
            flipEnvelope={flipEnvelope}
            showEnvelopeFront={showEnvelopeFront}
          />
        );
      }),
    [selectedIcon, square, height, width, icons]
  );
  return (
    <div
      className={cx('icons', className, {
        'icons--mobile': mobile,
      })}
    >
      {iconsMemo}
    </div>
  );
};
